<script>
import LoginView from "@/components/login/LoginView.vue";
import { mapState } from "vuex";
import apiHelper from "@/utils/apiHelpers";
import store from "@/utils/store";
import { productCategories } from "@/utils/lists";

export default {
    name: "header-component",
    components: {
        LoginView,
    },
    data() {
        return {
            isUserMenu: false,
            showLoginModal: false,
            logoOnlySrc: "/img/logo-only.png",
            logoSrc: "/img/logo.png",
            isLeftMenuOpen: false,
            isSmallScreen: false,
            dropdownOpen: false,
            categories: [],
            showNotifications: false,
            links: [],
        };
    },
    computed: {
        ...mapState([
            "isLoggedIn",
            "loggedUser",
            "isOpenAside",
            "noOfCartProducts",
            "isDarkMode",
            "showSubHeader",
            "newOrderCurrentStep",
            "noOfNotifications",
        ]),
        showNewOrderStep() {
            if (
                [
                    "/order/step-one/new",
                    "/order/next-step/account",
                    "/order/next-step/last",
                ].includes(this.$route.path)
            ) {
                return true;
            }
            return false;
        },
    },
    methods: {
        initializeLinks() {
            this.links = [
                {
                    name: "Products",
                    ref: "null",
                    path: "#",
                    options: this.categories,
                    type: "dropdown",
                },
                {
                    name: "On Sale",
                    ref: "onSaleSection",
                    path: "/",
                    type: "link",
                },
                {
                    name: "Best Sellers",
                    ref: "bestSellerSection",
                    path: "/",
                    type: "link",
                },
            ];
        },
        openLoginModal() {
            this.showLoginModal = true;
        },
        closeLoginModal() {
            this.showLoginModal = false;
        },
        async logout() {
            this.toggleUserMenu();
            await apiHelper.logout(this.$router, this.loggedUser.timelog_id);
        },
        toggleAsideMenu() {
            store.commit("setToggleAsideMenu", !this.isOpenAside);
        },
        toggleUserMenu(path = null) {
            this.isUserMenu = !this.isUserMenu;
            if (path) {
                this.$router.push(path);
            }
        },
        toggleLogo() {
            if (this.isLoggedIn) {
                if (this.isGuest) {
                    this.$router.push("/shop");
                } else {
                    this.toggleAsideMenu();
                }
            } else {
                this.$router.push("/shop");
            }
        },
        checkScreenSize() {
            this.isSmallScreen = window.innerWidth <= 768;
        },
        toggleLeftMenu() {
            this.isLeftMenuOpen = !this.isLeftMenuOpen;
        },
        handleOutsideClick(event) {
            // Close the menu if the click is outside both the navbar and the toggle icon
            const navbar = this.$refs.navbar;
            const menuToggle = this.$refs.menuToggle;
            const menu = this.$refs.userMenu;
            const pCategories = this.$refs.pCategories;
            if (
                this.isLeftMenuOpen &&
                !navbar.contains(event.target) &&
                !menuToggle.contains(event.target)
            ) {
                this.isLeftMenuOpen = false;
            }
            if (menu && !menu.contains(event.target)) {
                this.isUserMenu = false;
            }
            const isInAnyDropdown =
                Array.isArray(pCategories) &&
                pCategories.some((el) => el && el.contains(event.target));

            if (!isInAnyDropdown) {
                this.dropdownOpen = false;
            }
        },
        showNotificationList() {
            this.showNotifications = !this.showNotifications;
            this.notificationList = [];
        },
        navigateTo(link) {
            if (link.type === "link") {
                localStorage.setItem("focusRef", link.ref);
                localStorage.setItem("fromHeader", "true");
                this.$router.push({
                    path: "/shop",
                    query: { focus: link.ref },
                });
            }
        },
        async filterProductsByCategories(category) {
            if (category) {
                this.dropdownOpen = false;
                this.$router.push(
                    `shop-products?category_name=${category.name.toLowerCase()}`,
                );
            }
        },
    },
    async mounted() {
        this.categories = await productCategories();
        this.initializeLinks();
        window.addEventListener("click", this.handleOutsideClick);
        window.addEventListener("resize", this.checkScreenSize);
        this.checkScreenSize();
    },
    beforeUnmount() {
        window.removeEventListener("click", this.handleOutsideClick);
        window.removeEventListener("resize", this.checkScreenSize);
    },
};
</script>
